import { render, staticRenderFns } from "./StandaloneContainer.vue?vue&type=template&id=3d8c67c6"
import script from "./StandaloneContainer.vue?vue&type=script&lang=js"
export * from "./StandaloneContainer.vue?vue&type=script&lang=js"
import style0 from "./StandaloneContainer.vue?vue&type=style&index=0&id=3d8c67c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports